export default __webpack_public_path__ + "static/media/10.8f4737e6.svg";